// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"StudentLoansHero_heroBanner__moMAc","overlay":"StudentLoansHero_overlay__Y8Yqy","title":"StudentLoansHero_title__PKGHQ","subtitle":"StudentLoansHero_subtitle__itlBG"};